export interface SettlementType {
  submittedTime?: string[];
  submittedTimeFrom?: string;
  submittedTimeTo?: string;
  requestDate?: string;
  withdrawDate?: string;
  code?: string;
  destinationBank?: string;
  wage?: string;
  amount?: string;
  status?: string;
  iban?: string;
}

// eslint-disable-next-line no-shadow
export enum DestinationBank {
  Central = 10,
  Sanat = 11,
  Mellat = 12,
  Refah = 13,
  Maskan = 14,
  Sepah = 15,
  Keshavarzi = 16,
  Melli = 17,
  Tejarat = 18,
  Saderat = 19,
  ToseeSaderat = 20,
  Post = 21,
  ToseeTaavon = 22,
  Tosee = 51,
  Ghavamin = 52,
  Karafarin = 53,
  Parsian = 54,
  EghtesadNovin = 55,
  Saman = 56,
  Pasargad = 57,
  Sarmaye = 58,
  Sina = 59,
  Mehr = 60,
  Shahr = 61,
  Ayande = 62,
  Ansar = 63,
  Gardeshgari = 64,
  Hekmat = 65,
  Dey = 66,
  IranZamin = 69,
  Resalat = 70,
  Khavarmiane = 78,
}

// eslint-disable-next-line no-shadow
export enum SettlementStatusEnum {
  FAILED = 1,
  IN_PROGRESS = 2,
  TRANSFERRED = 3,
}

export const DestinationBankObj = [
  {
    locale: "Central",
    no: DestinationBank.Central,
  },
  {
    locale: "Sanat",
    no: DestinationBank.Sanat,
  },
  {
    locale: "Mellat",
    no: DestinationBank.Mellat,
  },
  {
    locale: "Refah",
    no: DestinationBank.Refah,
  },
  {
    locale: "Maskan",
    no: DestinationBank.Maskan,
  },
  {
    locale: "Sepah",
    no: DestinationBank.Sepah,
  },
  {
    locale: "Keshavarzi",
    no: DestinationBank.Keshavarzi,
  },
  {
    locale: "Melli",
    no: DestinationBank.Melli,
  },
  {
    locale: "Tejarat",
    no: DestinationBank.Tejarat,
  },
  {
    locale: "Saderat",
    no: DestinationBank.Saderat,
  },
  {
    locale: "ToseeSaderat",
    no: DestinationBank.ToseeSaderat,
  },
  {
    locale: "Post",
    no: DestinationBank.Post,
  },
  {
    locale: "ToseeTaavon",
    no: DestinationBank.ToseeTaavon,
  },
  {
    locale: "Tosee",
    no: DestinationBank.Tosee,
  },
  {
    locale: "Ghavamin",
    no: DestinationBank.Ghavamin,
  },
  {
    locale: "Karafarin",
    no: DestinationBank.Karafarin,
  },
  {
    locale: "Parsian",
    no: DestinationBank.Parsian,
  },
  {
    locale: "EghtesadNovin",
    no: DestinationBank.EghtesadNovin,
  },
  {
    locale: "Saman",
    no: DestinationBank.Saman,
  },
  {
    locale: "Ayande",
    no: DestinationBank.Ayande,
  },
  {
    locale: "Pasargad",
    no: DestinationBank.Pasargad,
  },
  {
    locale: "Sarmaye",
    no: DestinationBank.Sarmaye,
  },
  {
    locale: "Sina",
    no: DestinationBank.Sina,
  },
  {
    locale: "Mehr",
    no: DestinationBank.Mehr,
  },
  {
    locale: "Tejarat",
    no: DestinationBank.Tejarat,
  },
  {
    locale: "Ansar",
    no: DestinationBank.Ansar,
  },
  {
    locale: "Gardeshgari",
    no: DestinationBank.Gardeshgari,
  },
  {
    locale: "Hekmat",
    no: DestinationBank.Hekmat,
  },
  {
    locale: "Shahr",
    no: DestinationBank.Shahr,
  },
  {
    locale: "Keshavarzi",
    no: DestinationBank.Keshavarzi,
  },
  {
    locale: "Melli",
    no: DestinationBank.Melli,
  },
  {
    locale: "EghtesadNovin",
    no: DestinationBank.EghtesadNovin,
  },
  {
    locale: "Sepah",
    no: DestinationBank.Sepah,
  },
  {
    locale: "Dey",
    no: DestinationBank.Dey,
  },
  {
    locale: "IranZamin",
    no: DestinationBank.IranZamin,
  },
  {
    locale: "Resalat",
    no: DestinationBank.Resalat,
  },
  {
    locale: "Khavarmiane",
    no: DestinationBank.Khavarmiane,
  },
];

export const StatusObj = [
  {
    locale: "failed",
    no: SettlementStatusEnum.FAILED,
  },
  {
    locale: "inProgress",
    no: SettlementStatusEnum.IN_PROGRESS,
  },
  {
    locale: "transferred",
    no: SettlementStatusEnum.TRANSFERRED,
  },
];
